import styled from "styled-components";

export const OuterContainer = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 2fr;
  inline-size: 100%;
  block-size: fit-content;
  background-color: #ffffff;
  padding-block: 0.5rem;
  column-gap: 3rem;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 10px 0;
  z-index: 2;
  position: relative;
  right: 10%;
  width: max-content;
`;


export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-block-start: 0.7rem;

  .button.button.button-sm {
    block-size: 25px !important;
    min-block-size: 25px !important;

    span {
      font-size: 13px !important;
    }
  }
`;

export const HSumBoxOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SumLine = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 3px;
`;

export const Line = styled.div`
  border-bottom: solid 1px #bdbdbd;
  margin: 0 5% 0 45%;
`;